import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';

@Component({
  selector: 'app-geoastra-software',
  templateUrl: './geoastra-software.component.html',
  styleUrls: ['../landing/landing.component.scss', '../landing/headers.css', './geoastra-software.component.scss']
})
export class GeoAstraSoftwareComponent implements OnInit, OnDestroy {
  rtkExpertSiteUrl = '';

  lightboxOpen = false;
  lightboxSrc = '';
  lightboxAlt = '';

  private fragSub: Subscription | null = null;

  constructor(
    private readonly auth: AuthService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly userService: UserService,
  ) {}

  ngOnInit(): void {
    this.userService.getPublicSiteUrls().subscribe({
      next: (cfg) => {
        this.rtkExpertSiteUrl = (cfg?.rtkExpertSiteURL || '').trim();
      },
      error: () => {
        this.rtkExpertSiteUrl = '';
      }
    });

    this.fragSub = this.route.fragment.subscribe((frag) => {
      if (!frag) {
        return;
      }
      setTimeout(() => this.scrollTo(frag), 80);
    });
  }

  ngOnDestroy(): void {
    this.fragSub?.unsubscribe();
  }

  scrollTo(anchorId: string): void {
    document.getElementById(anchorId)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  loginNtripCaster(): void {
    this.auth.login();
  }

  goToNtripCasterLearnMore(): void {
    this.router.navigate(['/landing-ntrip-caster']).then(() => {
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 50);
    });
  }

  private buildRtkExpertUrl(path: string, query?: string): string {
    const base = (this.rtkExpertSiteUrl || 'https://rtk-expert.geoastra.com').replace(/\/+$/, '');
    const p = (path || '/').startsWith('/') ? path : `/${path}`;
    return `${base}${p}${query ? `?${query}` : ''}`;
  }

  loginRtkExpert(): void {
    window.location.href = this.buildRtkExpertUrl('/', 'autoLogin=1');
  }

  goToRtkExpertLearnMore(): void {
    window.location.href = this.buildRtkExpertUrl('/');
  }

  openLightbox(src: string, alt: string): void {
    this.lightboxSrc = src;
    this.lightboxAlt = alt;
    this.lightboxOpen = true;
  }

  closeLightbox(): void {
    this.lightboxOpen = false;
    this.lightboxSrc = '';
    this.lightboxAlt = '';
  }
}
